<div class="focus-border" id="search-trigger">
  <mat-form-field floatLabel="always" appearance="outline" class="search-form-field search-form-topnav d-none d-md-block d-lg-inline-block serach-box">
    <span matSuffix>
      <i class="fa fa-search search-icon" aria-hidden="true"></i>
    </span>
    <mat-label>
      <span i18n="search form placeholder@@search-form-placeholder" class="d-none">Search</span>
    </mat-label>
    <input #searchInput
           matInput
           placeholder="Search"
           i18n-placeholder="search form placeholder@@search-form-placeholder"
           (keypress)="onElementClick($event)"
           (keyup)="onKeyUp($event)"
           (click)="onElementClick($event)"
           autocomplete="off">
  </mat-form-field>
  <!-- mobile search button -->
  <div class="d-block d-md-none d-lg-none serach-icon">
    <app-toolbar-button [title]="'Search'" [buttonClass]="{'clickable':true}" (click)="onElementClick($event)">
      <i class="fa fa-search" aria-hidden="true"></i>
      <span class="sr-only">Search</span>
    </app-toolbar-button>
  </div>
</div>
